module.exports = __webpack_public_path__ + "static/img/sharetips.c604f83.1763978124417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sharetips.png
// module id = kg+M
// module chunks = 69